import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Button from 'shared/button';
import Modal from 'components/modal';

export default function Dialog({
  className,
  buttonType,
  children,
  confirmLabel,
  headerClassName,
  headerText,
  icon,
  iconClassName,
  show,
  onConfirm,
  onHide,
  ...props
}) {
  let ConfirmButton;
  switch (buttonType) {
  case 'danger':
    ConfirmButton = Button.Danger;
    break;
  default:
    ConfirmButton = Button.Primary; 
  }

  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal
      {...props}
      className={className}
      show={show}
      onHide={onHide}
    >
      {headerText && <Modal.Header className={headerClassName} closeButton>{headerText}</Modal.Header>}
      <Modal.Body className="text-center py-5">
        {icon && <FontAwesomeIcon className={classNames('mb-4', iconClassName)} icon={icon} size="3x" />}
        {children}

        <div className="mt-4">
          <Button.Cancel className="mr-3" onClick={onHide} />
          <ConfirmButton label={confirmLabel || 'Yes'} onClick={handleConfirm} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

Dialog.propTypes = {
  buttonType: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  confirmLabel: PropTypes.string,
  headerClassName: PropTypes.string,
  headerText: PropTypes.string,
  icon: PropTypes.object,
  iconClassName: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
